import useInfo from "./use-info";
import { useViewState } from "../context/view";

const useColor = () => {
  // setup ----------------------------------------------------------------------
  const {
    info,
    pick,
    ldcuid,
    bar,
    rnfo0,
    rnfo1,
    pfrPick,
    // topPfrList,
    srvy,
    nfidlst,
  } = useInfo();
  const view = useViewState();

  // conditionf ----------------------------------------------------------------------
  const conditionF = (obj) => {
    const {
      rdbtOps,
      slopeOps,
      pmtrOps,
      rdnetOps,
      pubtrOps,
      pbuldOps,
      buldeOps,
      stairOps,
      sdwkOps,
    } = info;
    const p = obj.properties;

    // Lookup maps: selected label → condition function
    const rdbtMap = {
      "3m 미만": (f) => f.properties.road_bt < 3,
      "3m이상 ~ 8m미만": (f) =>
        f.properties.road_bt >= 3 && f.properties.road_bt < 8,
      "8m이상 ~ 9m미만": (f) =>
        f.properties.road_bt >= 8 && f.properties.road_bt < 9,
      "9m이상 ~ 10m미만": (f) =>
        f.properties.road_bt >= 9 && f.properties.road_bt < 10,
      "10m이상 ~ 12m미만": (f) =>
        f.properties.road_bt >= 10 && f.properties.road_bt < 12,
    };
    const slopeMap = {
      "10.00 초과": (f) => f.properties.slope_lg >= 10,
      "6.00 ~ 10.00": (f) =>
        f.properties.slope_lg >= 6 && f.properties.slope_lg < 10,
      "3.00 ~ 6.00": (f) =>
        f.properties.slope_lg >= 3 && f.properties.slope_lg < 6,
      "1.00 ~ 3.00": (f) =>
        f.properties.slope_lg >= 1 && f.properties.slope_lg < 3,
      "0.00 ~ 1.00": (f) =>
        f.properties.slope_lg >= 0 && f.properties.slope_lg < 1,
    };
    const pmtrMap = {
      아스팔트: (f) => f.properties.pmtr_se === 1,
      콘크리트: (f) => f.properties.pmtr_se === 3,
      블록: (f) => f.properties.pmtr_se === 4,
      비포장: (f) => f.properties.pmtr_se === 5,
      "우레탄 등": (f) => ![1, 3, 4, 5].includes(f.properties.pmtr_se),
    };
    const rdnetMap = {
      "1.35초과": (f) => f.properties.rdnet_ac >= 1.35,
      "1.14 ~ 1.35": (f) =>
        f.properties.rdnet_ac >= 1.14 && f.properties.rdnet_ac < 1.35,
      "0.98 ~ 1.14": (f) =>
        f.properties.rdnet_ac >= 0.98 && f.properties.rdnet_ac < 1.14,
      "0.82 ~ 0.98": (f) =>
        f.properties.rdnet_ac >= 0.82 && f.properties.rdnet_ac < 0.98,
      "0.00 ~ 0.82": (f) =>
        f.properties.rdnet_ac >= 0.0 && f.properties.rdnet_ac < 0.82,
    };
    const pubtrMap = {
      "500 초과": (f) => f.properties.pubtr_ac >= 500,
      "350 ~ 500": (f) =>
        f.properties.pubtr_ac >= 350 && f.properties.pubtr_ac < 500,
      "200 ~ 350": (f) =>
        f.properties.pubtr_ac >= 200 && f.properties.pubtr_ac < 350,
      "100 ~ 200": (f) =>
        f.properties.pubtr_ac >= 100 && f.properties.pubtr_ac < 200,
      "0 ~ 100": (f) =>
        f.properties.pubtr_ac >= 0 && f.properties.pubtr_ac < 100,
    };
    const pbuldMap = {
      "2000 이상": (f) => f.properties.pbuld_fa >= 2000,
      "1000 ~ 2000": (f) =>
        f.properties.pbuld_fa >= 1000 && f.properties.pbuld_fa < 2000,
      "500 ~ 1000": (f) =>
        f.properties.pbuld_fa >= 500 && f.properties.pbuld_fa < 1000,
      "100 ~ 500": (f) =>
        f.properties.pbuld_fa >= 100 && f.properties.pbuld_fa < 500,
      "0 ~ 100": (f) =>
        f.properties.pbuld_fa >= 0 && f.properties.pbuld_fa < 100,
    };
    const buldeMap = {
      "20개 이상": (f) => f.properties.bulde_de >= 20,
      "11~20개": (f) =>
        f.properties.bulde_de >= 11 && f.properties.bulde_de < 20,
      "6~10개": (f) => f.properties.bulde_de >= 6 && f.properties.bulde_de < 11,
      "1~5개": (f) => f.properties.bulde_de >= 1 && f.properties.bulde_de < 6,
      "출입구 없음 (0)": (f) => f.properties.bulde_de < 1,
    };
    const stairMap = {
      설치: (f) => f.properties.stair_at === "1",
      미설치: (f) => f.properties.stair_at === "0",
    };
    const sdwkMap = {
      "단측 설치": (f) => f.properties.sdwk_se === 2,
      "양측 설치": (f) => f.properties.sdwk_se === 3,
      미설치: (f) => f.properties.sdwk_se === 1,
    };

    const buildConditions = (selected, map) =>
      selected?.length ? selected.map((s) => map[s]).filter(Boolean) : [];

    const rdbtConditions = buildConditions(rdbtOps?.selected, rdbtMap);
    const slopeConditions = buildConditions(slopeOps?.selected, slopeMap);
    const pmtrConditions = buildConditions(pmtrOps?.selected, pmtrMap);
    const rdnetConditions = buildConditions(rdnetOps?.selected, rdnetMap);
    const pubtrConditions = buildConditions(pubtrOps?.selected, pubtrMap);
    const pbuldConditions = buildConditions(pbuldOps?.selected, pbuldMap);
    const buldeConditions = buildConditions(buldeOps?.selected, buldeMap);
    const stairConditions = buildConditions(stairOps?.selected, stairMap);
    const sdwkConditions = buildConditions(sdwkOps?.selected, sdwkMap);

    return pick
      ? pick === p.nf_id
      : (rdbtConditions.length === 0 || rdbtConditions.some((c) => c(obj))) &&
          (slopeConditions.length === 0 ||
            slopeConditions.some((c) => c(obj))) &&
          (pmtrConditions.length === 0 || pmtrConditions.some((c) => c(obj))) &&
          (rdnetConditions.length === 0 ||
            rdnetConditions.some((c) => c(obj))) &&
          (pubtrConditions.length === 0 ||
            pubtrConditions.some((c) => c(obj))) &&
          (pbuldConditions.length === 0 ||
            pbuldConditions.some((c) => c(obj))) &&
          (buldeConditions.length === 0 ||
            buldeConditions.some((c) => c(obj))) &&
          (stairConditions.length === 0 ||
            stairConditions.some((c) => c(obj))) &&
          (sdwkConditions.length === 0 || sdwkConditions.some((c) => c(obj))) &&
          (ldcuid && ldcuid[4].slice(2) !== "000"
            ? p.leglcd_se === `${ldcuid[4]}`
            : ldcuid && ldcuid[4].slice(2) === "000"
              ? p.leglcd_se.slice(0, 2) === ldcuid[4].slice(0, 2)
              : true);
  };

  // getrskclr ----------------------------------------------------------------------
  const getRskClr = (obj) => {
    const mode =
      rnfo0 && rnfo1 ? "사고예측" : rnfo0 ? "사고" : rnfo1 ? "예측" : "미선택";
    const check = mode === "사고" ? rnfo0 : mode === "예측" ? rnfo1 : [];
    const rskVal =
      mode === "사고"
        ? Number(4 - obj.properties.pedac_rk) //pedac_rk: 0 안전 4 위험
        : mode === "예측"
          ? Number(4 - obj.properties.pred) //pred: 0 안전 4 위험
          : Number(4 - obj.properties.pedac_rk);

    // case pick ----------------------------------------
    if (pick) {
      if (obj.properties.nf_id === pick) {
        if (rskVal === 0) {
          return [221, 0, 22, 255 * 0.8];
        } else if (rskVal === 1) {
          return [233, 141, 120, 255 * 0.8];
        } else if (rskVal === 2) {
          return [242, 212, 146, 255 * 0.8];
        } else if (rskVal === 3) {
          return [121, 194, 165, 255 * 0.8];
        } else if (rskVal === 4) {
          return [0, 175, 185, 255 * 0.8];
        } else {
          return [0, 0, 0, 255 * 0.05];
        }
      } else {
        return [0, 0, 0, 255 * 0.05];
      }
    }
    // case 사고예측모두선택 ----------------------------------------
    else if (mode === "사고예측") {
      var cond0 = rnfo0
        .map((item, id) => {
          if (item) {
            switch (id) {
              case 0:
                return (d) => d.properties.pedac_rk === 4;
              case 1:
                return (d) => d.properties.pedac_rk === 3;
              case 2:
                return (d) => d.properties.pedac_rk === 2;
              case 3:
                return (d) => d.properties.pedac_rk === 1;
              case 4:
                return (d) => d.properties.pedac_rk === 0;
              default:
                return null;
            }
          } else {
            return null;
          }
        })
        .filter((cond) => cond !== null);

      var cond1 = rnfo1
        .map((item, id) => {
          if (item) {
            switch (id) {
              case 0:
                return (d) => d.properties.pred === 4;
              case 1:
                return (d) => d.properties.pred === 3;
              case 2:
                return (d) => d.properties.pred === 2;
              case 3:
                return (d) => d.properties.pred === 1;
              case 4:
                return (d) => d.properties.pred === 0;
              default:
                return null;
            }
          } else {
            return null;
          }
        })
        .filter((cond) => cond !== null);

      const finalcheck =
        cond0.length !== 0 &&
        cond0.some((condition) => condition(obj)) &&
        cond1.length !== 0 &&
        cond1.some((condition) => condition(obj)) &&
        (ldcuid && ldcuid[4].slice(2) !== "000"
          ? obj.properties.leglcd_se === `${ldcuid[4]}`
          : ldcuid && ldcuid[4].slice(2) === "000"
            ? obj.properties.leglcd_se.slice(0, 2) === ldcuid[4].slice(0, 2)
            : true);

      return finalcheck ? [0, 98, 175, 255 * 0.75] : [0, 0, 0, 255 * 0.05];
    }
    // case 나머지:사고예측중하나선택/모두미선택 ----------------------------------------
    else {
      // case 시군구 ----------------------------------------
      if (ldcuid && ldcuid[4].slice(2) !== "000") {
        if (obj.properties.leglcd_se === `${ldcuid[4]}`) {
          if (rskVal === 0) {
            return check[0] ? [221, 0, 22, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 1) {
            return check[1]
              ? [233, 141, 120, 255 * 0.8]
              : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 2) {
            return check[2]
              ? [242, 212, 146, 255 * 0.8]
              : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 3) {
            return check[3]
              ? [121, 194, 165, 255 * 0.8]
              : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 4) {
            return check[4] ? [0, 175, 185, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
          } else {
            return [0, 0, 0, 255 * 0.05];
          }
        } else {
          return [0, 0, 0, 255 * 0.05];
        }
      }
      // case 시도 ----------------------------------------
      else if (ldcuid && ldcuid[4].slice(2) === "000") {
        if (obj.properties.leglcd_se.slice(0, 2) === ldcuid[4].slice(0, 2)) {
          if (rskVal === 0) {
            return check[0] ? [221, 0, 22, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 1) {
            return check[1]
              ? [233, 141, 120, 255 * 0.8]
              : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 2) {
            return check[2]
              ? [242, 212, 146, 255 * 0.8]
              : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 3) {
            return check[3]
              ? [121, 194, 165, 255 * 0.8]
              : [0, 0, 0, 255 * 0.05];
          } else if (rskVal === 4) {
            return check[4] ? [0, 175, 185, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
          } else {
            return [0, 0, 0, 255 * 0.05];
          }
        } else {
          return [0, 0, 0, 255 * 0.05];
        }
      }
      // case 시도시군구미선택 ----------------------------------------
      else {
        if (rskVal === 0) {
          return check[0] ? [221, 0, 22, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
        } else if (rskVal === 1) {
          return check[1] ? [233, 141, 120, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
        } else if (rskVal === 2) {
          return check[2] ? [242, 212, 146, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
        } else if (rskVal === 3) {
          return check[3] ? [121, 194, 165, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
        } else if (rskVal === 4) {
          return check[4] ? [0, 175, 185, 255 * 0.8] : [0, 0, 0, 255 * 0.05];
        } else {
          return [0, 0, 0, 255 * 0.05];
        }
      }
    }
  };

  // getroadcolor ----------------------------------------------------------------------
  const getRoadColor = (obj) => {
    if (!obj.properties.nf_id) {
      //for int points
      if (view.zoom < 11) {
        return [255, 255, 255, 0];
      } else {
        return [255, 255, 255];
      }
    }
    // if (hvid === obj.properties.nf_id) {
    //   return [255, 255, 0];
    // }
    if (bar === 1) {
      if (ldcuid && ldcuid[4].slice(2) === "000") {
        if (obj.properties.leglcd_se.slice(0, 2) === ldcuid[4].slice(0, 2)) {
          return [0, 98, 175, 255 * 0.75];
        } else {
          return [102, 135, 160, 255 * 0.35];
        }
      } else if (ldcuid && ldcuid[4].slice(2) !== "000") {
        if (obj.properties.leglcd_se === ldcuid[4]) {
          return [0, 98, 175, 255 * 0.75];
        } else {
          return [102, 135, 160, 255 * 0.35];
        }
      } else {
        return [102, 135, 160, 255 * 0.35];
      }
    } else if (bar === 2) {
      //for selected info(filter)
      return getRskClr(obj);
    } else if (bar === 3 && pfrPick) {
      // const selectedRank = topPfrList.find(
      //   (item) => item.nf_id === pfrPick
      // )?.ped_fitr_rank;

      // const matchingIds = topPfrList
      //   .filter((item) => item.ped_fitr_rank === selectedRank)
      //   .map((item) => item.nf_id);

      // if (
      //   matchingIds.includes(obj.properties.nf_id) ||
      //   obj.properties?.ROAD_NM ===
      //     topPfrList.find((item) => item.nf_id === pfrPick)?.road_nm
      // ) {
      if (nfidlst.includes(obj.properties.nf_id)) {
        return [245, 167, 212];
      } else {
        return [0, 0, 0, 255 * 0.05];
      }
    } else if (bar === 4) {
      if (srvy) {
        if (nfidlst.includes(obj.properties.nf_id)) {
          return [0, 98, 175, 255 * 0.75];
        } else {
          return [102, 135, 160, 255 * 0.35];
        }
      } else {
        if (conditionF(obj)) {
          //for selected info(filter)
          // if (hov === obj.properties.nf_id) {
          //   return [0, 255, 0];
          // } else {
          return [0, 98, 175, 255 * 0.75];
          // }
        } else {
          //for unselected info(filter)
          // if (hov === obj.properties.nf_id) {
          //   return [0, 255, 0];
          // } else {
          return [102, 135, 160, 255 * 0.35];
          // }
        }
      }
    } else {
      return [102, 135, 160, 255 * 0.35];
    }
  };

  // getaccpcolor ----------------------------------------------------------------------
  const getAccpColor = (obj, hvid) => {
    if (hvid === obj.properties.acdnt_no) {
      return [255, 255, 0];
    }
    const ldc = obj.properties.ldc;
    // ldc 필드가 타일에 없으면 지역 필터 없이 항상 표시
    if (ldc == null) {
      return [255, 0, 0];
    }
    const ldcStr = String(ldc);
    if (ldcuid && ldcuid[4].slice(2) === '000') {
      return ldcStr.slice(0, 2) === ldcuid[4].slice(0, 2)
        ? [255, 0, 0]
        : [102, 135, 160, 255 * 0.35];
    } else if (ldcuid) {
      return ldcStr.slice(0, 5) === String(ldcuid[4]).slice(0, 5)
        ? [255, 0, 0]
        : [102, 135, 160, 255 * 0.35];
    } else {
      return [255, 0, 0];
    }
  };
  return { getRoadColor, conditionF, getAccpColor };
};

export default useColor;
